import React from "react";

function Checkout() {
  return (
    <div className="container">
      <h2>Finalizar Compra</h2>
      <p>Informações de pagamento e checkout.</p>
    </div>
  );
}

export default Checkout;
